import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import { useCart } from '../CartContext';
import '../stylesheets/Shopping.css';
import MZ from '../img/Icons/MarketZ.png';
import Back from '../img/Icons/Goback.png';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore';
import Address from './AddAdress';
import Payment from './Payment';

const Shopping = () => {
  const { user } = useAuth();
  const { cartItems } = useCart();
  const [shippingInfo, setShippingInfo] = useState([]);
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState(false);
  const [payment, setPayment] = useState(false);

  useEffect(() => {
    const fetchShippingInfo = async () => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        setPhone(user.phone || '');
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const currentShippingInfo = userData.ShippingInfo || [{ address: '' }];
          setShippingInfo(currentShippingInfo);
          if (!userData.ShippingInfo) {
            await updateDoc(userDocRef, {
              ShippingInfo: arrayUnion({ address: '' })
            });
          }
        }
      }
    };

    fetchShippingInfo();
  }, [user]);

  return (
    <>
      <form className='Purchases-cont'>
        <header className='Purchases-head'>
          <div className='Purchases-title-cont'>
            <img src={MZ} alt="MarkeZeta Icon" className='Purchases-mkz-img' />
            <h1 className='Purchases-title'>Market Z</h1>
          </div>
          <div className='Purchases-back-cont'>
            <button className='goback-btn'>
              <img className='Purchases-back-img' src={Back} alt="go back image" />
              <span className='goback-txt'>Volver</span>
            </button>
          </div>
        </header>
        <div className='Purchases-body'>
          <div className='Purchases-tittle-cont'>
            <h1 className='Purchases-tittle'>Compra pendiente</h1>
          </div>
          {cartItems.length > 0 ? (
            <div className='Purchase'>
              {cartItems.map((item) => (
                <h4 className='address-txt' key={item.id}>
                  -X{item.amount} {item.ItemName}
                </h4>
              ))}
              <div className='price-cont'>
                <h3 className='price-txt'>Total a Pagar:</h3>
                <h4 className='price-txt'>$53000 COP</h4>
              </div>
              <h3 className='My-Address-txt'>Tus direcciones:</h3>
              <div className='My-Address-cont'>
                {shippingInfo.map((info, index) => (
                  <div className='My-Address-list-cont' key={index}>
                    {
                      info.address ? (
                        <>
                          <div className='My-Address-txt-cont'>
                            <span>-{info.address}</span>
                            <input type="checkbox" className="Address-check" value={info.address} />
                          </div>
                        </>
                      ) : (
                        <h3></h3>
                      )
                    }
                  </div>
                ))}
                <button className='My-Address-btn' onClick={(event) => {
                  event.preventDefault();
                  setAddress(!address);
                }}>
                  <p>Agregar dirección</p>
                </button>
              </div>
            </div>
          ) : (
            <p className='Shopping-name'>No tienes productos en tu carrito.</p>
          )}
          <div className='Shopping-field-txt-cont'>
            <h2>Nombre de quien recibe</h2>
            <input type="text" />
          </div>
          <div className='Shopping-field-txt-cont'>
            <h2>Teléfono</h2>
            <input type="text" defaultValue={phone} />
          </div>
          <div className='Shopping-field-txt-cont'>
            <h2>Teléfono Alternativo</h2>
            <input type="text" />
          </div>
          <div className='Shopping-btns-cont'>
            <button className='Shopping-btn' type='submit'>
              <h2>X</h2>
              <h4>Cancelar</h4>
            </button>
            <button onClick={(event) => {
              event.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setPayment(!payment);
            }}

            >
              <p>Pagar</p>
            </button>
          </div>
        </div>
      </form>
      <Address
        address={address}
        setAddress={setAddress}
      />
      <Payment
        payment={payment}
        setPayment={setPayment}
      />
    </>
  )
}

export default Shopping;